import { useTheme } from '@mui/material';
import { PrimaryButton } from 'components/atoms';
import { InputFieldFloatingLabel } from 'components/molecules/formFields';

import { FormBuilder } from './form-builder';
import { LoginFormProps, SubmitButtonProps } from './types';

const SubmitButton = ({ disabled }: SubmitButtonProps) => (
  <PrimaryButton disabled={disabled || false} style={{ width: '100%' }} type="submit">
    SIGN IN
  </PrimaryButton>
);

export const LoginForm = ({ onSubmit }: LoginFormProps) => {
  const theme = useTheme();
  const formFields = [
    {
      component: InputFieldFloatingLabel,
      fieldKey: 'username',
      label: 'Email Address',
      labelCss: {
        background: theme.palette.background.paper,
      },
      required: true,
      type: 'email',
      wrapperCss: {
        marginBottom: '15px',
        width: '100%',
      },
    },
    {
      component: InputFieldFloatingLabel,
      fieldKey: 'password',
      label: 'Password',
      labelCss: {
        background: theme.palette.background.paper,
      },
      required: true,
      type: 'password',
      isPassword: true,
      wrapperCss: {
        marginBottom: '15px',
        width: '100%',
      },
    },
  ];

  return (
    <FormBuilder
      formFields={formFields}
      onSubmit={onSubmit}
      submitButton={SubmitButton}
    />
  );
};
